<template>
  <app-layout :show-drawer="false" class="page-choose-destination-wrapper d-flex">
    <v-layout slot="main-content" column class="page-choose-destination flex-grow-1 max-w-1200 mx-auto">
      <v-layout>
        <v-row no-gutters>
          <v-col cols="7" class="pa-5 d-flex flex-column">
            <h3 class="flex-grow-0 py-2 align-center">
              Preview
            </h3>
            <v-card class="mt-5 pa-3 border-yellow-100 bg-yellow-200" outlined>
              <span class="text-body-2">
                Great job! This template is a great pre-click content. Choose a post-click content stream to pair with it to create a complete content experience.
              </span>
            </v-card>
            <v-layout class="flex-grow-1 mt-3 overflow-y-auto h-0">
              <v-layout class="h-fit-content">
                <Preview
                  v-if="template"
                  :channel="template.channel || ''"
                  :meta-data="template"
                  class="ma-0 mx-auto w-full flex-grow-0"
                  :line-clamp="5"
                />
              </v-layout>
            </v-layout>
          </v-col>
          <v-col cols="5" class="pa-5 d-flex flex-column">
            <v-layout class="flex-grow-0" justify-space-between align-center>
              <h3>
                Choose Destination
              </h3>
              <BtnCreateStream v-if="$helpers.get($auth, '$state.loggedIn')" class="flex-grow-0" :promotional-content-template-id="$route.params.id" />
            </v-layout>

            <v-card
              class="bg-white mt-5 flex-grow-1 overflow-hidden d-flex flex-column"
              outlined
              rounded="lg"
            >
              <v-tabs
                v-model="tab"
                class="flex-grow-0"
                color="primary"
                grow
              >
                <v-tab v-if="$helpers.get($auth, '$state.loggedIn')" class="text-normal-case">
                  Your Content Streams
                </v-tab>
                <v-tab class="text-normal-case">
                  New Stream Templates
                </v-tab>
              </v-tabs>

              <v-tabs-items
                v-model="tab"
                class="flex-grow-1"
              >
                <v-tab-item v-if="$helpers.get($auth, '$state.loggedIn')">
                  <v-layout
                    v-if="!$helpers.get(streams, 'length', 0)"
                    column
                    justify-center
                    align-center
                  >
                    <span class="text-subtitle-2 font-weight-semibold">
                      You don't have any existing content streams
                    </span>
                    <v-btn
                      large
                      color="primary"
                      class="mt-8"
                      @click="createNewContent"
                    >
                      Create a Content Stream
                    </v-btn>
                  </v-layout>
                  <v-layout v-else column>
                    <v-layout column class="overflow-y-auto flex-grow-1 h-0">
                      <v-layout wrap class="flex-0-0 pa-2">
                        <v-flex
                          v-for="(stream, index) in streams"
                          :key="`stream-${index}`"
                          sm6
                          class="pa-1 cursor-pointer"
                          @click="chooseStream(stream)"
                        >
                          <v-layout column class="pa-2">
                            <v-layout
                              class="grey rounded-lg overflow-hidden position-relative"
                              :class="{'is-choosing': stream.isChoosing}"
                            >
                              <v-img
                                :src="$helpers.getFilePreview(stream.seoSetting.featureImage) || svg.defaultCover"
                                aspect-ratio="1.7"
                                class="rounded-lg"
                              />
                              <v-img v-if="stream.isChoosing" class="is-choosing-icon" :src="svg.isChoosing" />
                            </v-layout>

                            <v-layout class="mt-3 text-body-2 font-weight-semibold d-inline-flex">
                              <StreamIcon :stream="stream" />
                              <EllipsisText :text="stream.name" />
                            </v-layout>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                    <v-layout column class="flex-grow-0">
                      <v-divider />
                      <v-layout class="pa-3">
                        <v-spacer />
                        <v-btn
                          color="primary"
                          large
                          :disabled="isSubmiting || !choosingStream"
                          @click="chooseStreamDestination"
                        >
                          Choose this stream as Destination
                        </v-btn>
                      </v-layout>
                    </v-layout>
                  </v-layout>
                </v-tab-item>
                <v-tab-item>
                  <v-layout column>
                    <v-layout column class="overflow-y-auto flex-grow-1 h-0">
                      <v-layout wrap class="flex-0-0 pa-2">
                        <v-flex
                          v-for="(template, index) in templates"
                          :key="`template-${index}`"
                          sm6
                          class="pa-1 cursor-pointer"
                          @click="chooseTemplate(template)"
                        >
                          <v-layout column class="pa-2">
                            <v-layout
                              class="grey rounded-lg overflow-hidden position-relative"
                              :class="{'is-choosing': template.isChoosing}"
                            >
                              <v-img
                                :src="$helpers.getFilePreview(template.seoSetting.featureImage) || svg.defaultCover"
                                aspect-ratio="1.7"
                                class="rounded-lg"
                              />
                              <v-img v-if="template.isChoosing" class="is-choosing-icon" :src="svg.isChoosing" />
                            </v-layout>
                            <v-layout class="mt-3 text-body-2 font-weight-semibold d-inline-flex">
                              <StreamIcon :stream="template" />
                              <EllipsisText :text="template.name" />
                            </v-layout>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                    <v-layout column class="flex-grow-0">
                      <v-divider />
                      <v-layout class="pa-3">
                        <v-spacer />
                        <v-btn
                          color="primary"
                          large
                          :disabled="isSubmiting || !choosingTemplate"
                          @click="chooseTemplateDestination"
                        >
                          Choose this stream as Destination
                        </v-btn>
                      </v-layout>
                    </v-layout>
                  </v-layout>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
      </v-layout>

      <PopupListingLibrary v-model="showPopupListingLibrary" :multiple="false" @choose="createFromListingTemplate" />
      <PopupLoginSignUp
        v-model="showPopupLoginSignUp"
        type="login"
        @success="chooseTemplateDestination"
      />
    </v-layout>
  </app-layout>
</template>

<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'
import AppLayout from '~/layouts/app'
import StreamIcon from '@/components/stream/icon.vue'
import Preview from '@/components/promote/partials/preview.vue'
import BtnCreateStream from '@/components/stream/btn-create-stream.vue'
import PopupListingLibrary from '@/components/content-item/listing/popup.library.vue'
import EllipsisText from '@/components/common/ellipsis-text.vue'
import PopupLoginSignUp from '@/components/auth/popups/popup.login-sign-up.vue'

export default {
  name: 'ChooseDestination',

  auth: false,

  components: {
    AppLayout,
    StreamIcon,
    Preview,
    BtnCreateStream,
    PopupListingLibrary,
    PopupLoginSignUp,
    EllipsisText
  },

  layout: 'none',

  async asyncData({ $axios, params, $auth, error }) {
    const data = {}
    try {
      const templateData = await $axios.$get(`/entry-content-templates/${params.id}`)
      data.template = get(templateData, 'promoteTemplate', {})

      if ($auth.loggedIn) {
        const streamsData = await $axios.$get('/streams', {
          params: {
            limit: 100
          }
        })
        data.streams = get(streamsData, 'docs', [])
      } else {
        data.streams = []
      }

      const templatesData = await $axios.$get('/streams/create?entities[]=template')
      data.templates = get(templatesData, 'templates', [])
    } catch (err) {
      error({ statusCode: get(err, 'response.status'), message: err.message })
    }
    return data
  },

  data: () => ({
    tab: null,
    svg: null,
    showPopupListingLibrary: false,
    showPopupLoginSignUp: false
  }),

  head() {
    return {
      meta: [
        {
          hid: 'apple-mobile-web-app-title',
          name: 'apple-mobile-web-app-title',
          property: 'apple-mobile-web-app-title',
          content: this.metaTitle
        },
        {
          hid: 'og:site_name',
          name: 'og:site_name',
          property: 'og:site_name',
          content: this.metaTitle
        },
        {
          hid: 'title',
          name: 'title',
          content: this.metaTitle
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$helpers.get(this.template, 'description')
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$helpers.get(this.template, 'tags', []).map(tag => tag.name).join(',')
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: 'article'
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.metaTitle
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$helpers.get(this.template, 'description')
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.metaImage || (this.$config.baseUrl + this.$helpers.getOrDefaultStreamCover())
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.metaTitle
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.$helpers.get(this.template, 'description')
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: this.metaImage || (this.$config.baseUrl + this.$helpers.getOrDefaultStreamCover())
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['submitting']),
    choosingStream() {
      return get(this, 'streams', []).find(stream => stream.isChoosing)
    },
    choosingTemplate() {
      return get(this, 'templates', []).find(stream => stream.isChoosing)
    },
    isSubmiting() {
      return get(this, 'submitting.createStream', false) || get(this, 'submitting.updateStream', false)
    },
    metaTitle() {
      if (this.template) {
        switch (this.template.channel) {
          case 'email':
          case 'fb_ads':
            return this.template.subject
          case 'sms':
            return this.template.purpose
          default:
            return get(this.template, 'settings.title')
        }
      }
      return ''
    },
    metaImage() {
      if (this.template && Array.isArray(this.template.featureImages) && this.template.featureImages.length) {
        return this.$helpers.getFilePreview(this.template.featureImages[0].imageUrl)
      }
      return ''
    }
  },

  created() {
    this.svg = {
      isChoosing: require('~/assets/images/icon/is-choosing.svg'),
      defaultCover: this.$helpers.getOrDefaultStreamCover()
    }
  },

  methods: {
    checkLogin() {
      const isLogin = this.$helpers.get(this.$auth, '$state.loggedIn')
      if (!isLogin) {
        this.showPopupLoginSignUp = true
        return false
      }
      return true
    },

    chooseStream(currentStream) {
      this.streams = this.streams.map((stream) => {
        stream.isChoosing = stream.isChoosing ? false : stream._id === currentStream._id
        return stream
      })
    },

    async chooseStreamDestination() {
      try {
        this.$store.commit('setSubmiting', { updateStream: true })
        const data = await this.$api.stream.updateStream(this.choosingStream._id, {
          promotionalContentTemplateId: this.$route.params.id
        })
        if (data.ok) {
          this.$notify.success({
            title: 'Stream',
            message: 'Save successfully!'
          })
          this.$router.push({
            name: 'streams-id-share',
            params: { id: this.choosingStream._id },
            query: {
              channel: this.template.channel,
              step: '3'
            }
          })
        }
      } catch (error) {
        this.$notify.error({
          title: 'Stream',
          message: this.$helpers.apiErrorMessage(error)
        })
      }
      this.$store.commit('setSubmiting', { updateStream: false })
    },

    async chooseTemplateDestination() {
      if (!this.checkLogin()) {
        return
      }
      if (this.choosingTemplate.originalContentItem) {
        this.showPopupListingLibrary = !this.showPopupListingLibrary
      } else {
        const data = await this.$axios.$post('/streams/from-template', {
          templateId: this.choosingTemplate._id,
          promotionalContentTemplateId: this.$route.params.id
        })
        this.$notify.success({
          title: 'Stream',
          message: 'Create success!'
        })
        this.$router.push({
          name: 'streams-id-share',
          params: { id: data._id },
          query: {
            channel: this.template.channel,
            step: '3'
          }
        })
      }
    },
    async createFromListingTemplate({ _id }) {
      try {
        const data = await this.$axios.$post('/streams/from-template', {
          templateId: this.choosingTemplate._id,
          listingId: _id,
          promotionalContentTemplateId: this.$route.params.id
        })
        this.$notify.success({
          title: 'Stream',
          message: 'Create success!'
        })
        this.$router.push({
          name: 'streams-id-share',
          params: { id: data._id },
          query: {
            channel: this.template.channel,
            step: '3'
          }
        })
      } catch (error) {
        const errorMessage = this.$helpers.apiErrorMessage(error)
        if (this.$helpers.apiStatusCode(error) !== 403) {
          this.$notify.error({
            title: 'Stream',
            message: errorMessage
          })
        }
      }
    },

    chooseTemplate(currentTemplate) {
      this.templates = this.templates.map((template) => {
        template.isChoosing = template.isChoosing ? false : template._id === currentTemplate._id
        return template
      })
    },

    async createNewContent() {
      const data = await this.$axios.$post('/streams/from-template', {
        promotionalContentTemplateId: this.$route.params.id
      })
      this.$notify.success({
        title: 'Stream',
        message: 'Create success!'
      })
      this.$router.push({
        name: 'streams-id-share',
        params: { id: data._id },
        query: {
          channel: this.template.channel,
          step: '3'
        }
      })
      this.$helpers.gaTracking('Dashboard', 'dashboard_create_click', 'from scratch', { event_type: 'from scratch' })
    }
  }
}
</script>

<style lang="scss">
.page-choose-destination-wrapper #main-content {
  background: #F8F8F7 !important;
}
</style>
<style lang="scss" scoped>
.is-choosing {
  box-shadow: 0 0 0 2px #2963EF;
  border-radius: 8px !important;
}
.is-choosing-icon {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
}
</style>
